import './intro.scss'
import { init } from "ityped";
import { useEffect, useRef } from "react";
//import FotoCV from "../../assets/FotoCV.png"
import me from "../../assets/me.png"
import down from "../../assets/down.png"


export default function Intro() {
  const textRef = useRef();

  useEffect(() => {
    init(textRef.current, {
      showCursor: true,
      backDelay: 1500,
      backSpeed:60,
      strings: ["Java", "React", "Python"],
    });
  }, []);

  return (
    <div className="intro" id="intro">
      <div className="left">
        <div className="imgContainer">
          <img src={me} alt="" />
        </div>
      </div>
      <div className="right">
        <div className="wrapper">
          <h2>Hola! Yo soy</h2>
          <h1>Nicolás Dominguez</h1>
          <h3>
            Programador en <span ref={textRef}></span>
          </h3>
        </div>
        <a href="#acerca">
          <img src={down} alt="" />
        </a>
      </div>
    </div>
  );
}
